import { getterTree, mutationTree } from 'typed-vuex'

interface Result {
  viewportWidth: number;
  breakpointNames: string[];
}

export const state = () => ({
  screenResolution: {
    viewportWidth: 0,
    breakpointNames: ['xs']
  } as Result
})

export const getters = getterTree(
  state,
  {
    xs(state) {
      return state.screenResolution.breakpointNames.includes('xs')
    },

    s(state) {
      return state.screenResolution.breakpointNames.includes('s')
    },

    m(state) {
      return state.screenResolution.breakpointNames.includes('m')
    },

    l(state) {
      return state.screenResolution.breakpointNames.includes('l')
    },

    xl(state) {
      return state.screenResolution.breakpointNames.includes('xl')
    },

    xxl(state) {
      return state.screenResolution.breakpointNames.includes('xxl')
    },

    isMobile(state, getters) {
      return getters.xs || getters.s || getters.m
    },

    isTablet(state, getters) {
      return getters.l
    },

    isDesktop(state, getters) {
      return getters.xl
    },

    isWide(state, getters) {
      return getters.xxl
    },

    resolution(state) {
      return state.screenResolution.viewportWidth
    },

    breakpointNames(state) {
      return state.screenResolution.breakpointNames
    }
  }
)

export const mutations = mutationTree(
  state,
  {
    setScreenResolution(state, screenResolution: Result) {
      state.screenResolution = screenResolution
    }
  }
)
